import type { FC } from 'react';
import React from 'react';
import Head from 'next/head';

import { makeScript, preConnect } from '../script';

export interface HotjarScriptProps {
  hjid?: string;
}

/**
 * Script function.
 *
 * @param ctx
 */
function hj(ctx: HotjarScriptProps) {
  if (ctx.hjid) {
    /*eslint-disable */
    // prettier-ignore
    (function(h,o,t,j){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:ctx.hjid,hjsv:6};
        var a=o.getElementsByTagName('head')[0];
        var r=o.createElement('script');r.async=!!1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    /*eslint-enable */
  }
}

export const HotjarScript: FC<HotjarScriptProps> = (props): JSX.Element => {
  const hjid = props.hjid || process.env.NEXT_PUBLIC_HOTJAR_ID;
  return (
    <Head>
      {preConnect('https://static.hotjar.com', hjid || false)}
      {makeScript(hj, { hjid })}
    </Head>
  );
};

export default HotjarScript;
